export const VaultDescription = ({ description }: { description: string }) => {
	return (
		<div className="flex flex-col gap-lg">
			<span className="typo-label-sm text-text-default">Description</span>
			<span className="typo-body-xs text-text-secondary">{description}</span>
		</div>
	);
};
